<template>
    <div :class="['page loyalty',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <p style="top:5px;text-align: center;width: 100%;margin: 20px 0px -10px 0px;font-size: 28px;z-index: 10;position: relative;">{{ topWords }}</p>
            <div>
                <img :src="srcLoyal" style="width: 290px;height:290px;margin-left: calc(50% - 145px);margin-bottom: -30px;" />
                <img :src="loyal1" style="width:100%" />
                <img :src="src" style="width: 220px;height:220px;margin-left: calc(50% - 110px)" >
                <p  class="ta-c" :style="{ color: infoFontColor }">{{ customerNo }}</p>
                <img v-if="loyal2" :src="loyal2" style="width:100%" />
            </div>
        </div>    
    </div>
    
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'

export default {
    name: 'loyalty',
    components: {
        VHeader,
    },
    mixins: [ pageOn ],
    created () {
        this.srcLoyal = 'https://api-v2.memberstar.club/loyalty/'+this.customer_id+'/'+this.campaign_id+'?d='+Date.now();
        this.src = 'https://api-v2.memberstar.club/qr?id='+encodeURIComponent('https://scanner.memberstar.club/loyal?y='+this.auth.id+'&c='+this.campaign_id);
    },
    computed: {
        auth () { return this.$store.state.auth },
        customer_id () { return this.$store.state.auth._id },
        client_id () { return this.$store.state.client_id },
        customerNo () { return this.$store.state.customerNo },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }, 
        infoFontColor () { return this.$store.state.infoFontColor },
        campaign_id () { return this.$store.state.loyaltyCampaign_id } 
    },
    data () {
        return {
            srcLoyal: '',
            src: '',
            customer: false,
            topWords: '',
            loyal1: '',
            loyal2: '',
            alertMessage: ''
        }
    },
    mounted () {
       this.startWatch();
       WebSoc.SEND({ t: 'getLoyaltyWords', data: { client_id: this.client_id, campaign_id: this.campaign_id }},resp => {
            this.topWords = resp.menu && resp.menu.text;
            this.loyal1 = resp.loyal1;
            this.loyal2 = resp.loyal2;
            this.alertMessage = resp.alertMessage;
       });
    },
    methods: {
        startWatch () {
            var { customer_id, client_id, campaign_id } = this;
            WebSoc.SEND({ t: 'startLoyaltyWatch', data: { customer_id, client_id, campaign_id } },resp => {
                console.log('startLoyaltyWatch resp',resp)
                if ( resp.update ) { this.srcLoyal += ('&d='+Date.now() ); this.$el.querySelector('.page-content').scrollTop = 0;  }
                if ( resp.rewards ) {
                    var alertMessage = this.alertMessage || ('You have completed '+resp.rewards+' card'+(resp.rewards > 1 ? 's' : '') )
                    Alert.message(alertMessage,() => {
                        //this.pushPage('survey');
                        this.back();
                    })
                }
            });
        },
        stopWatch () {
            var { customer_id, client_id, campaign_id } = this;
            WebSoc.SEND({ t: 'stopLoyaltyWatch', data: { customer_id, client_id, campaign_id } },() => {
                console.log('stopped')
            })
        },
        back () {
            this.startWatch();
            this.pageOn = false;
        },
        ...mapMutations(['pushPage'])
    }
}

</script>

<style>

</style>